import {
    DOMAIN,
    Header,
    ContentType,
    GetFormData,
    Method,
    http
} from './api-utils';
import AuthUtil  from "@/utils/AuthUtil";

/**
 * 修改密码
 * @param {*} param0
 */
export const modifyPassword = async ({verify, password, newPassword}) => {
    await http({
        method: Method.POST,
        url: DOMAIN + '/api/user/modify/password',
        data: {
            code: verify,
            password: password,
            newPassword: newPassword
        }
    });
};

/**
 * 修改用户信息
 * @param {*} param0
 */
export const modifyUserInfo = async ({
                                         avatar,
                                         nickname,
                                         gender,
                                         birthday
                                     }) => {
    const formData = GetFormData({
        avatarFile: avatar,
        nickName: nickname,
        gender,
        birthday
    });

    await http({
        method: Method.PUT,
        url: DOMAIN + '/api/user/update',
        headers: {
            [Header.ContentType]: ContentType.FormData
        },
        data: formData
    });
};

/**
 * 用户信息
 */
export const userInfo = async () => {
    const {data} = await http({
        method: Method.GET,
        url: DOMAIN + '/api/user/info'
    });


    let user = data.data;

    let info = {};
    if (user) {
        let {
            id,name,avatar,nickName,gender,birthday
        } = user || {};

        if (gender === '男') {
            gender = 0;
        } else {
            gender = 1;
        }

        info = {
            id,avatar,gender,birthday,
            username: name,
            nickname: nickName
        }

        AuthUtil.setUserInfo(info)
    }




    return {
        info
    };
};

/**
 * 联系人信息
 */
export const contactInfo = () => {
    return http({
        method: Method.GET,
        url: DOMAIN + '/cart/business/contact'
    })
        .then(res => res.data)
        .then(data => {
            const {name, telPhone: phone} = data;

            return {
                name,
                phone
            };
        });
};
